import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { ViError } from '@vi-iot/client/models';
import {
  FilterType,
  PowerLimitationControlCommandType,
  PowerLimitationTableList,
} from './power-limitation-history.model';

export namespace PowerLimitationHistoryActions {
  export const getPowerLimitationData = createActionGroup({
    source: '[Power Limitation] Get power limitation history data',
    events: {
      attempt: emptyProps(),
      success: props<{
        powerLimitationData: PowerLimitationTableList[];
      }>(),
      error: props<{
        error: ViError;
      }>(),
    },
  });

  export const updateFiltersByPowerLimitationType = createActionGroup({
    source: '[Power Limitation] Update filters by power limitation control command type',
    events: {
      attempt: props<{
        powerLimitationControlCommandType: PowerLimitationControlCommandType;
      }>(),
    },
  });

  export const updateFiltersByDate = createActionGroup({
    source: '[Power Limitation] Update filters by date',
    events: {
      attempt: props<{
        filterDateAndType: {
          type: FilterType;
          date: moment.Moment;
        };
      }>(),
    },
  });

  export const clearState = createActionGroup({
    source: '[Power Limitation] Clear state',
    events: {
      attempt: emptyProps(),
    },
  });
}
